<template>
  <div>
    <v-layout row wrap fill-height>
      <v-flex xs12 fill-height>
        <EventStatusBoard
            v-if="eventStatusBoard.active"
            :screener="meta"
        >
            <AppLoader v-if="eventStatusBoard.loading" :message="eventStatusBoard.message"></AppLoader>
        </EventStatusBoard>
        <component
          v-else
          :is="movieStream.currentPlayer"
          :playerState.sync="movieStream.playerState"
          :meta="meta"
          :consumer="consumer"
          @preRollEnded="onPrerollEnd"
          @movieEnded="onMovieEnd"
          @OnMovieIndexChange="OnMovieIndexChange"
        ></component>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import PrerollPlayer from "../player/PrerollPlayer";
import MoviePlayer from "../player/MoviePlayer";
import EventStatusBoard from "@/components/screener/EventStatusBoard";
export default {
  name: "MovieStream",
  props: {
    meta: {
      type: Object,
      default: null,
    },
    previewMode: {
      type: Boolean,
      default: false
    },
    consumer: {
      type: Object,
      default: null
    }
  },
  components: {
    PrerollPlayer,
    MoviePlayer,
    EventStatusBoard
  },
  data() {
    return {
      movieStream: {
        currentPlayer: null,
        playerState: null,
      },
      eventStatusBoard: {
          active: false,
          loading: false,
          message: null,
          error: true,
          isResolved: false
      }
    };
  },
  computed: {

    ...mapGetters("player", {
      getScreenerConfig: "getScreenerConfig",
    }),
  },
  mounted() {
    this.resolveMovieStream();
  },
  methods: {
    async resolveMovieStream() {
      /**
       * 1. Resolve which player need to be used
       * Preroll player or Movie player
       */
      await this.resolvePlayerState();
      this.resolveCurrentPlayer(this.meta);

      /**
       * 2. Load player state like currentTime, mute/unmute from
       * global state
       */
    },

    /**
     * Resolve player type
     */
    resolveCurrentPlayer(meta) {
      let player = (meta.pre_roll && (!this.movieStream.playerState.prerollEnded)) ? "PrerollPlayer" : "MoviePlayer";
      return this.movieStream.currentPlayer = player;
    },

    /**
     * Load all the player configurationg from local browser or
     * global state
     */
    async resolvePlayerState() {
      const availablePlayerState = await this.getScreenerConfig(this.meta.screener_id)
      let playerState = availablePlayerState ? Object.assign({},availablePlayerState) :null;                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         console.log('Fetched State --->',playerState)

      //To set the initial index correct
      //  if(playerState && playerState.currentMovieIndex){
      //   this.$emit('OnMovieIndexChange', playerState.currentMovieIndex);
      // }

      /**
       * If no any player state is not found or preview mode is enabled
       * then dump the default state
       */
      if(!playerState){
          let default_state             = this.DEFINES.PLAYER_CONFIG.SCREENER;
          default_state.screener_id     = this.meta.screener_id;
          await this.$store.dispatch("player/updateScreenerConfig",default_state)
          return this.movieStream.playerState = default_state;
      }

      /**
       * Else use configured state
       */
      this.movieStream.playerState = playerState;
      return
    },

    /**
     * Handel preroll end
     */
    async onPrerollEnd() {
      await this.$store.dispatch("player/markPrerollEnded",{
        screener_id: this.meta.screener_id
      })
      .then((response) => {
        this.resolveMovieStream();
      })

    },

    /**
     * Show/Hide loadermessages between the switching
     */
    showMessageBtwSwitching() {
      this.eventStatusBoard.active = true;
      this.eventStatusBoard.loading = true;
      this.eventStatusBoard.message = "Please wait while we are fetching your screening";
    },

    hideSwitchingMessage() {
      this.eventStatusBoard.active = false;
      this.eventStatusBoard.loading = false;
      this.eventStatusBoard.message = null;
    },

    async onMovieEnd(previousPlayerState) {
      let nextMovieIndex = (previousPlayerState.currentMovieIndex += 1);

      /**
       * If next index is not available the its simply mean movie
       * have been ended
       */
      if (!this.meta.screener_urls[nextMovieIndex]) {
        return this.$emit("movieStreamEnded");
      }

      await this.$store.dispatch('player/updateMovieIndex',{
        screener_id: this.meta.screener_id,
        currentMovieIndex: nextMovieIndex
      })
      .then(async(response)=> {
        this.showMessageBtwSwitching();
        await this.resolveMovieStream();
        this.hideSwitchingMessage();

      })
    },

    OnMovieIndexChange(index){
      this.$emit('OnMovieIndexChange', index);
    }
  },
};
</script>
<style scoped>
</style>
